import {
  ComputedFieldProps,
  LocalizedString,
  TextChildren,
} from "@dbn/omnichannel-design-system-g4p";
import { option } from "fp-ts";
import { Option } from "fp-ts/Option";
import { useFormatIncomeCurrency } from "../../../intl";
import { useTenantCurrency } from "../../../Common/useTenantCurrency";
import { NumberField } from "../../../Common/NumberField/NumberField";

type Props = {
  fieldProps: ComputedFieldProps<Option<number>>;
  description?: LocalizedString;
  placeholder: LocalizedString;
  autoFocus?: boolean;
  min?: number;
  max?: number;
  allowNegative?: boolean;
  assistiveText?: TextChildren;
  currency?: string;
  disabled?: boolean;
  label: LocalizedString;
};

export function AmountWithCurrencyField(props: Props) {
  const formatCurrency = useFormatIncomeCurrency();
  const tenantCurrency = useTenantCurrency();

  return (
    <NumberField
      {...props}
      {...props.fieldProps}
      locale="sk"
      rightContent={option.some(
        formatCurrency(props.currency || tenantCurrency)
      )}
    />
  );
}
